import { RelocationOrderStatus } from "@/api-schema-enums";

export const ALLOW_DESTINATION_LOCATION_STATUSES = [
  RelocationOrderStatus.Completed,
  RelocationOrderStatus.TransportCompanyAwaitingDeliveryAcceptance,
  RelocationOrderStatus.BranchRejectedDamagedVehicle,
  RelocationOrderStatus.BranchRejectedMissingKeys,
  RelocationOrderStatus.BranchRejectedMissingVehicle,
  RelocationOrderStatus.BranchRejectedWrongVehicle,
];

export const REQUIRES_DRIVER_STATUSES = [
  RelocationOrderStatus.TransportCompanyInTransit,
  RelocationOrderStatus.Completed,
  RelocationOrderStatus.TransportCompanyAwaitingDeliveryAcceptance,
  RelocationOrderStatus.BranchRejectedDamagedVehicle,
  RelocationOrderStatus.BranchRejectedMissingKeys,
  RelocationOrderStatus.BranchRejectedMissingVehicle,
  RelocationOrderStatus.BranchRejectedWrongVehicle,
];

export const OWN_AXLE_ALLOWED_STATUSES = [
  RelocationOrderStatus.BranchRejectedDamagedVehicle,
  RelocationOrderStatus.BranchRejectedMissingKeys,
  RelocationOrderStatus.BranchRejectedMissingVehicle,
  RelocationOrderStatus.BranchRejectedWrongVehicle,
  RelocationOrderStatus.Completed,
  RelocationOrderStatus.Cancelled,
  RelocationOrderStatus.TransportCompanyAwaitingDeliveryAcceptance,
];
